const videoIdRegex = /^[a-zA-Z0-9_-]{11}$/i;
const isValidYoutubeVideoId = (videoId) => videoIdRegex.test(videoId);
const sanitizedYoutubeVideoId = (videoId) => {
  const match = videoId.match(videoIdRegex);
  return match ? match[0] : null;
};

export { isValidYoutubeVideoId, sanitizedYoutubeVideoId };
